<template>
  <login-wrap>
    <span class="idp-label"> {{ string.idpLabel }}</span>
    <idp-login-buttons class="idp-login" />
    <another-account />
  </login-wrap>
</template>

<script>
import LoginWrap from '@/components/auth/LoginWrap.vue';
import IdpLoginButtons from '@/elements/auth/IdpLoginButtons.vue';
import anotherAccount from '@/elements/auth/anotherAccount.vue';

export default {
  name: 'LoginSso',
  components: {
    LoginWrap,
    IdpLoginButtons,
    anotherAccount,
  },
  computed: {
    string() {
      return {
        idpLabel: this.$gettext('Continue with'),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.idp-login {
  margin-bottom: 40px;
}
.idp-label {
  color: $gray-700;
  margin-bottom: 20px;
}
</style>
